import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataUnit } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_UNIT = defineMasterdataEntity<MasterdataUnit>({
  name: 'unit',
  responseKey: 'units',
  displayWith: (u) => keyName(u.key, u.name),
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-ruler',
  title: 'Einheitensuche',
  label: 'Einheit',
  placeholder: 'Einheit suchen...',
  columns: [
    {
      label: 'Einheit',
      type: 'entity',
      icon: 'fa-regular fa-ruler',
      value: (e) => keyName(e.key, e.name),
    },
    { label: 'Schlüssel', value: (e) => e.key },
    { label: 'Bezeichnung', value: (e) => e.name },
    { label: 'Umrechnungsfaktor', value: (e) => e.factor, align: 'end' },
  ],
});
